// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__Dacpo","activityMenu":"styles_activityMenu__Y9Nfw"};